import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { notificationService, type NotificationCounts } from '@/services/api/notificationService';

export const useNotificationStore = defineStore('notification', () => {
  // State
  const counts = ref<NotificationCounts>({
    pending_claims: 0,
    pending_tires: 0,
    total: 0
  });
  
  const loading = ref(false);
  const error = ref<string | null>(null);
  
  // Getters
  const totalCount = computed(() => counts.value.total);
  const pendingClaimsCount = computed(() => counts.value.pending_claims);
  const pendingTiresCount = computed(() => counts.value.pending_tires);
  
  // Actions
  async function fetchCounts() {
    loading.value = true;
    error.value = null;
    
    try {
      counts.value = await notificationService.getCounts();
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch notification counts';
      console.error('Error fetching notification counts:', err);
    } finally {
      loading.value = false;
    }
  }
  
  // Auto-refresh every 30 seconds
  let refreshInterval: number | null = null;
  
  function startAutoRefresh() {
    // Fetch immediately
    fetchCounts();
    
    // Then refresh every 30 seconds
    refreshInterval = window.setInterval(() => {
      fetchCounts();
    }, 30000);
  }
  
  function stopAutoRefresh() {
    if (refreshInterval) {
      clearInterval(refreshInterval);
      refreshInterval = null;
    }
  }
  
  return {
    // State
    counts,
    loading,
    error,
    // Getters
    totalCount,
    pendingClaimsCount,
    pendingTiresCount,
    // Actions
    fetchCounts,
    startAutoRefresh,
    stopAutoRefresh
  };
});

